import React from "react";
// import "./1099.css";
import "../../GlobalCss/SPF/1099.css";
import { useState, useEffect } from "react";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import { DeleteOutlined, UploadOutlined, ReloadOutlined, LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Layout, Modal, message, Spin, Image, Upload } from "antd";
import { BaseUrl, JsonConfig, FormConfig, UserName } from "../../Repository/BaseRepository";
import TenNinetyNineTable from "../../Components/1099Table/1099Table";
import axios from "axios";
import { ErrorMessage, routes, SuccessMessage } from "../../Utils/Utils";
import { Redirect, Link } from "react-router-dom";
import { getAccountsCubeData } from "../../Repository/TenNinetyNineRepository";
import Cookies from "js-cookie";
const { Header, Content } = Layout;
// import { useTenantStyle } from "../../Utils/Utils";
const TenNinetyNine = () => {
    // useTenantStyle();
    const [hrSourceFile, setHrSourceFile] = useState([]);
    const [spin, setSpin] = useState(false)
    const [hrUploader, setHrUploader] = useState("");
    const [tableLoader, setTableLoader] = useState(false)
    const [griddata, setGriddata] = useState([])
    const tenantName = Cookies.get("tenant_name");
    useEffect(() => {
        callAccoutsCube();
    }, [])
    const callAccoutsCube = async() => {
        try{
            setTableLoader(true)
            const res = await getAccountsCubeData();
            if(res !== null && res.length > 0){
                setGriddata(res);
            }
            setTableLoader(false)
        }
        catch{
            ErrorMessage("Cannot able to get data, please try again")
        }
    }
    const handleUpload = async (options) => {
        try {
            setSpin(true)
            const { file, onSuccess, onError } = options;
            const updatedDeductionFile = { file, status: "uploading" }
            const formData = new FormData();
            formData.append("ACFIle", file);
            setHrSourceFile([])
            setHrUploader(file.name);
            const response = await axios.post(`${BaseUrl}_1099_Contract_Accounting/UploadAccountContractFile`, formData, FormConfig)
            if (response.data.statusCode === 200) {
                callAccoutsCube();
                onSuccess(file)
                message.success(`File uploaded successfully`);
                updatedDeductionFile.status = "done"
                setHrSourceFile([updatedDeductionFile])
                setHrUploader('')
                setSpin(false)
            }
            else if (response.data.statusCode === 400) {
                onError(file)
                message.error(response.data.message);
                updatedDeductionFile.status = "error"
                setHrSourceFile([updatedDeductionFile])
                setHrUploader('')
                setSpin(false)
            }
            else {
                onError(file)
                message.error(response.data.message);
                updatedDeductionFile.status = "error"
                setHrSourceFile([updatedDeductionFile])
                setHrUploader('')
                setSpin(false)
            }
        }
        catch (error) {
            message.error(`File upload failed`);
            setHrUploader('')
            setSpin(false)
        }
    }
    const itemRender = (originNode, file) => {
        let statusColor;
        if (file.status === "done") {
            statusColor = "green";
        } else if (file.status === "error") {
            statusColor = "#f55451";
        }
        let fileExists = false;
        if (hrSourceFile.length > 0) {
            fileExists = true;
        }
        return <>
            <div style={{ display: "flex", height: 'auto', height: 'auto', width: 400, wordWrap: "break-word", marginTop: "15px",}}>
                <div style={{ color: statusColor, height: 'auto', display: "flex", wordWrap: "break-word", borderRadius: "4px" }}>{fileExists ?
                    <div style={{ height: 'auto', width: 'fit-content', wordBreak: 'break-all', }}>{hrSourceFile[0].file.name} </div> : null}</div>
                <DeleteOutlined style={{ marginLeft: 5 }} onClick={() => setHrSourceFile([])} />
            </div>
        </>;
    };
    const AddNewRecord = async() => {

    }
    return (<>
       <Layout className="ten99-layout">
        <SideNavBar />
        <Layout className="ten99-inner-layout">
            <Header className="preview-header-class">
                <Navbar />
            </Header>
            <Content className="ten99-content">
                <div className="otherpage-buttons">
                    <Link to={`/${tenantName}/1099crawl`}>
                        <Button className="page-button">Audit/Review</Button>
                    </Link>
                    <Button className="currentpage-button">Input file upload</Button>
                    <Link to={`/${tenantName}/1099masterfile`}>
                        <Button className="page-button">Masterfile</Button>
                    </Link>
                </div>
                <div className="ten99-row1">
                    <div className="inputfile-upload">
                        <Upload
                            className="hr-upload-file"
                            name="file"
                            customRequest={handleUpload}
                            itemRender={itemRender}
                            fileList={hrSourceFile}
                            accept=".xls,.xlsx"
                            onRemove={() => setHrSourceFile([])}
                        >
                            <div className="hr-content-file">
                                <span className="hrfile-name">Upload File</span>
                                {spin ? (
                                    <Spin
                                        indicator={
                                            <LoadingOutlined
                                                className="upload-spinner"
                                                spin
                                            />
                                        }
                                    />
                                ) : (
                                    <Image
                                        src="/Images/uploadimg (2).png"
                                        className="upload-image"
                                        showPreviewIcon={false}
                                        preview={false}
                                    />
                                )}
                            </div>
                        </Upload>
                        {hrUploader.length > 0 ? (
                            <div className="uploaded-file-name">{hrUploader}</div>
                        ) : null}
                    </div>
                </div>
                <div className="ten99-row3">
                    <TenNinetyNineTable
                        tableLoader={tableLoader}
                        griddata={griddata}
                        setGriddata={setGriddata}
                    />
                </div>
            </Content>
        </Layout>
    </Layout>
    </>)
}
export default TenNinetyNine;